'use strict';

import $ from 'jquery';

export default class CourseDetailsAnchor {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    this.$sidebar = $(".course-details-anchor__sidebar", this.$selector);
    this.$sidebarHeight = this.$sidebar.outerHeight(true);

    this.$anchorLinks = $(
      ".course-details-anchor__sidebar__nav--list a",
      this.$selector
    );
    this.$anchorMobileButton = $(
      ".course-details-anchor__sidebar__nav--dropdown button",
      this.$selector
    );

    this.$contentMain = $(".course-details-anchor__main", this.$selector);
    this.$containerBottom =
      this.$selector.offset().top + this.$selector.outerHeight();

    this.$headerHeight = $(".site-header").outerHeight();

    if (selfInit) this.init();
  }

  init() {
    this.setupSticky();

    this.$anchorLinks.on('click', (e) => {
      e.preventDefault();

      this.setupAnchorLinks(e);
    });

    this.$anchorMobileButton.on("click", (e) => {
      e.preventDefault();

      this.$sidebar.toggleClass("expanded");
    });
  }

  setupAnchorLinks(e) {
    let spacer = $(window).width() >= 1024 ? 20 : 75;

    let id = $(e.currentTarget).attr("href").substring(1);
    let $target = $("#" + id);

    if ($target.length) {
      $('html, body').animate(
        {
          scrollTop: $target.offset().top - this.$headerHeight - spacer,
        },
        500
      );
    }

    if (this.$sidebar.hasClass("expanded")) {
      this.$sidebar.removeClass("expanded");
    }
  }

  setupSticky() {
    $(window).on('scroll load', () => {
      this.$sidebarPosition = this.$sidebar.offset().top;
      let isMobile = $(window).width() < 1024;
      let sidebarPosition = this.$sidebarPosition

      let currentScroll = $(window).scrollTop() + this.$headerHeight;
      let anchorBottomPosition = isMobile
        ? this.$containerBottom - 150
        : this.$containerBottom;

      if (currentScroll >= sidebarPosition) {
        this.$sidebar.addClass("sticky");
        console.log(currentScroll, anchorBottomPosition);
        
        if (isMobile && (currentScroll > anchorBottomPosition)) {
          this.$sidebar.addClass("faded");
        } else {
          this.$sidebar.removeClass("faded");
        }
      } else {
        this.$sidebar.removeClass("sticky");
      }
    });
  }
}
